import React from "react";
import "./Footer.css";
import "../../i18n";
import { github, linkedin } from "../../assets/";
import { useTranslation } from "react-i18next";

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="wrapper">
        <div className="footer-main">
          <div className="footer-social">
            <a
              className="socialContainer containerOne"
              href="https://github.com/michalskijakub"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={github} alt="github" className="socialSvg githubSvg" />
            </a>
            <a
              class="socialContainer containerTwo"
              href="https://www.linkedin.com/in/jmichalski00/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={linkedin}
                alt="linkedin"
                className="socialSvg linkedinSvg"
              />
            </a>
          </div>
          <div className="footer-email">
            <p className="footer-text">michalskijakubaleksander@gmail.com</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
